var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-steps',_vm._g(_vm._b({},'b-steps',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.stepsItems),function(item){return _c('b-step-item',_vm._b({key:item.name},'b-step-item',Object.assign({}, item),false),[_vm._t(item.name)],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }